import { render } from "./AccountantEdit.vue?vue&type=template&id=cb9d9c7c&scoped=true"
import script from "./AccountantEdit.vue?vue&type=script&lang=js"
export * from "./AccountantEdit.vue?vue&type=script&lang=js"

import "./AccountantEdit.vue?vue&type=style&index=0&id=cb9d9c7c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9d9c7c"]])

export default __exports__